import { render, staticRenderFns } from "./BCXFooter.vue?vue&type=template&id=286782ce"
import script from "./BCXFooter.vue?vue&type=script&lang=ts"
export * from "./BCXFooter.vue?vue&type=script&lang=ts"
import style0 from "./BCXFooter.vue?vue&type=style&index=0&id=286782ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports